import { TextFieldModule } from "@angular/cdk/text-field";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialogModule } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSelectModule } from "@angular/material/select";
import { MatSliderModule } from "@angular/material/slider";
import { RouterModule } from "@angular/router";
import { QuestionnaireCompletedPageComponent } from "@gloria-public/questionnaire/views/questionnaire-completed-page/questionnaire-completed-page.component";
import { EncodeQuestionComponent } from "@gloria-public/questionnaire/views/questionnaire-page/components/encode-question/encode-question.component";
import { CommonTranslateModule } from "@shared/utils/common-translate.module";
import { TranslationValuePipe } from "@shared/utils/helpers/translation-value.pipe";
import { QuestionnaireActionDialogComponent } from "./questionnaire-page/components/questionnaire-action-dialog/questionnaire-action-dialog.component";
import { QuestionnairePageComponent } from "./questionnaire-page/questionnaire-page.component";
import { LocalizedDatePipe } from "@shared/pipes/localized-date.pipe";

const materialModules = [
  MatProgressSpinnerModule,
  MatSelectModule,
  MatIconModule,
  MatSliderModule,
  MatDatepickerModule,
  MatInputModule,
  MatDialogModule,
  MatExpansionModule,
];

@NgModule({
  declarations: [
    QuestionnairePageComponent,
    EncodeQuestionComponent,
    QuestionnaireCompletedPageComponent,
    QuestionnaireActionDialogComponent,
  ],
  providers: [],
  imports: [
    CommonModule,
    CommonTranslateModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    TextFieldModule,
    TranslationValuePipe,
    LocalizedDatePipe,
    ...materialModules,
  ],
})
export class QuestionnairesModule {}
